import { GppGood, Search } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CircularProgress, TextField, ThemeProvider, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ComplaintTimeline } from "../../components/complaint/ComplaintTimeline";
import { useAlert } from "../../components/contextProviders/AlertProvider";
import logo from '../../images/logo.png';
import { ComplaintService } from "../../services/ComplaintService";
import { ComplaintDTO } from "../../types/ComplaintDTO";
import { lightTheme } from "../complaint-form/ComplaintForm";
import './ComplaintFollowUp.scss';

const ComplaintFollowUp: FC = () => {
	const [complaint, setComplaint] = useState<ComplaintDTO>({} as ComplaintDTO);
	const [loading, setLoading] = useState(false);
	const { id, protocol } = useParams<{ id: string, protocol: string }>();
	const [searched, setSearched] = useState(protocol || '');
	const navigate = useNavigate();
	const { showError } = useAlert();
	const service = new ComplaintService();

	const handleProtocolChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value.replace(/[^0-9]/g, '');
		setSearched(value);
	};

	const handleClickGoHome = () => {
		navigate(`/canal-de-denuncias/${id}/acompanhamento/`);
	};

	const handleSearch = async () => {
		if (!searched) {
			showError("Por favor, informe o protocolo.");
			return;
		}
		navigate(`/canal-de-denuncias/${id}/acompanhamento/${searched}`);
		loadComplaint();
	};

	const handleNewComplaint = () => {
		navigate(`/canal-de-denuncias/${id}`);
	};

	const loadComplaint = async () => {
		if (!protocol && !searched) {
			return;
		}
		setLoading(true);
		const response = await service.getComplaint(searched || '');
		if (response && response.data) {
			setComplaint(response.data);
		} else {
			showError("Denúncia não encontrada!");
		}
		setLoading(false);
	};

	useEffect(() => {
		loadComplaint();
	}, []);

	return (
		<ThemeProvider theme={lightTheme}>
			<div className="complaint-follow-up-page">
				<Box className="form-container">
					<img src={logo} alt="Logo da empresa" className="form-logo" onClick={handleClickGoHome}/>
					<header className="form-header-follow-up">
						<Typography variant="h5" component="h1">Acompanhar denúncia</Typography>
					</header>
					<main className="form-body-follow-up">
						<Typography variant="body1" align="center">
							Informe o protocolo da denúncia para acompanhar o andamento.
						</Typography>
						<TextField
							label="Protocolo"
							value={searched}
							onChange={handleProtocolChange}
							fullWidth
							variant="outlined"
							placeholder="Digite o número do protocolo"
							inputProps={{ maxLength: 13 }}
						/>
						<Button
							variant="contained"
							color="primary"
							onClick={handleSearch}
							disabled={loading}
							startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Search />}
							fullWidth
						>
							Consultar
						</Button>
						{loading && <CircularProgress sx={{ mt: 2 }} />}
						{complaint && complaint.id && !loading && (
							<Card variant="outlined" className="timeline-card">
								<CardContent>
									<Typography variant="h6" component="h2" sx={{ mb: 2 }}>Situação da denúncia</Typography>
									<ComplaintTimeline complaint={complaint} />
								</CardContent>
							</Card>
						)}
						{searched && !complaint && !loading && (
							<Typography
								color="error"
								sx={{ mt: 2 }}>Nenhuma denúncia encontrada para o protocolo informado.
							</Typography>
						)}
						<Box className="action-buttons-follow-up">
							<Button
								variant="outlined"
								color="primary"
								onClick={handleNewComplaint}
							>
								Fazer nova denúncia
							</Button>
						</Box>
					</main>
					<footer className="form-footer-follow-up">
						<GppGood />
						<Typography variant="body2">Seu acompanhamento é anônimo e seguro</Typography>
					</footer>
				</Box>
			</div>
		</ThemeProvider>
	);
}

export default ComplaintFollowUp;